/**
 * Created by dmarthak on 23/01/18.
 */

define(function(require, exports, module) {
    'use strict';

    // @ngInject
    exports.mobileTokenGeneratorService = function ($http, $window, lpPortal, lpCoreUtils, $q) {

        var servicePath = lpPortal.root + "/services/rest", deviceInfoPlugin, appPinPlugin, deviceInfo = null, payload = {};
        var config = {
            generateDeviceTokenUrl: servicePath + "/v1/registration/device/token"
        };

        if ($window.cxp && $window.cxp.mobile && $window.cxp.mobile.plugins) {
            deviceInfoPlugin = $window.cxp.mobile.plugins['DeviceInfo'];
            appPinPlugin = $window.cxp.mobile.plugins['AppPin'];
        }

        //methods
        this.generateDeviceToken = function(){
            var deferred = $q.defer();
            generateTokenFromPlugin().then(function(response){
                $http.post(config.generateDeviceTokenUrl, response).then(function(response){
                    deferred.resolve(response.data);
                }, function(response){
                    deferred.reject(response);
                });
            });
            return deferred.promise;
        };

        function generateTokenFromPlugin(){
            var deferred = $q.defer();
            if(deviceInfoPlugin){
                deviceInfoPlugin.getInfo(function (response) {
                    if(response){
                        deviceInfo = response;
                        payload = {
                            deviceType: JSON.stringify(deviceInfo.deviceType),
                            accessTokenAppString:deviceInfo.accessTokenAppString
                        };
                        deferred.resolve(payload);
                    }
                }, function (response) {
                    deferred.reject(response);
                });
            }else{deferred.reject("failed");}
            return deferred.promise;
        }

        this.saveAppToken = function(resolve, reject, token){
            if(appPinPlugin){
                appPinPlugin.saveAppToken(resolve, reject, token);
            }
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ./scripts/mobileTokenGenerator.js
// module id = 8
// module chunks = 0